import styled from '@emotion/styled';
import { Link } from 'gatsby';
import React from 'react';

const Container = styled('div')`
  margin: 0 auto;
`;
const Inner = styled('div')`
  max-width: 640px;
`;

const Copy = styled('div')`
  font-family: 'DM Sans', sans-serif;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 24px;
  margin-top: 3rem;
  a {
    color: #fff;
    display: inline-block;
  }
`;

export default () => (
  <Container>
    <Inner className={`border-top`}>
      <Copy>
        *Estimated increase based on projected difference between the most efficient and least efficient withdrawal strategy for a 62 year old married couple from Florida with $1 million in assets split equally between IRA, Roth and taxable accounts. User and user’s spouse were assumed to have a salary while working of $80,000 and $30,000 respectively and both retired and started taking Social Security at age 62. A retirement replacement ratio was utilized to provide an estimate of post-retirement spending based on pre-retirement income. To learn more about SmartDraw's personalized withdrawal strategies and the assumptions that make them work, please click here.
      </Copy>
    </Inner>
  </Container>
);
